import { useContext } from 'react';

import WarningContextProvider from 'containers/WarningContext';

const useWarning = () => {
  return useContext(WarningContextProvider.Context);
};

export default useWarning;
